import React, { Component } from 'react';
import Layout from './components/Layout/Layout';
import LandingPage from './containers/LandingPage/LandingPage';

import Profile from './containers/Profile/Profile';
import Rules from './containers/Rules/Rules';
import Quiz from './containers/Quiz/Quiz';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';

import { connect } from 'react-redux';
import * as actions from './store/actions/index'

class App extends Component {

  componentDidMount () {
    this.props.onTryAutoSignup();
  }

  render() {
    
    let routes = (
      <Switch>
        <Route path="/" exact component={LandingPage} />
        <Route path="/pravila" component={Rules} />
        <Redirect to="/" />
      </Switch>
    );

    if (this.props.isAuthenticated) {
      routes = (
        <Switch>
          <Route path="/pravila" component={Rules} />
          <Route path="/profil" component={Profile} />
          <Route path="/kviz" component={Quiz} />
          <Route path="/" exact component={LandingPage} />
        </Switch>
      );
    }

    return (
      <Layout path={this.props.curPath}>
        {routes}
      </Layout>
    );
  }
}

const mapStateToProps = state => {
	return {
    isAuthenticated: state.auth.token !== null,
    curPath: state.my.currentPath,
	};
}


const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch( actions.authCheckState() )
  }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js